import React, { useEffect } from 'react'
import { VariableRequests } from './VariableRequests';
import { AbstructVar } from '../../../components/general/general-component/abstruct-component/AbstructVar';

function FilterRequest({ translate, noPadding, bigTitle, titleBtn, FunctionBtn }) {
    const { dispatch, navigate, langLocal } = AbstructVar()
    const { state, setStateCustom, setLoad } = VariableRequests();
    const Filter = (e) => {
        e.preventDefault()
        //dispatch(filterEvaluationType(state.name, state.creative_work_type_id, setLoad))
    }
    return (
        <div className='filteruser' dir={langLocal === 'ar' ? "rtl" : "ltr"} style={noPadding && { padding: "24px 10px 10px 0px" }} >
            <div className='div_top_table' >
                {
                    bigTitle ? <h2 className="main_title_color" >{translate('search_filter')}</h2> :
                        <h3>{translate('search_filter')}</h3>
                }
                {
                    titleBtn && (
                        <button className='btn_top_table' onClick={FunctionBtn} >{titleBtn}</button>
                    )
                }
            </div>
            <div className='div_filter' >
                <input className={`input_filter ${langLocal === 'ar' ? "margin_left_25" : "margin_right_25"} `} placeholder={translate('location')} onChange={(e) => setStateCustom('location', e.target.value)} />
                <input type='date' className={`input_filter ${langLocal === 'ar' ? "margin_left_25" : "margin_right_25"} `} placeholder={translate('request_date')} onChange={(e) => setStateCustom('request_date', e.target.value)} />
                <input type='date' className={`input_filter ${langLocal === 'ar' ? "margin_left_25" : "margin_right_25"} `} placeholder={translate('needed_on')} onChange={(e) => setStateCustom('needed_on', e.target.value)} />
                <select className={`select_filter  ${langLocal === 'ar' ? "margin_left_25" : "margin_right_25"} `} onChange={(e) => setStateCustom('status', e.target.value)} >
                    <option disabled selected >{translate('status')}</option>
                    <option value={true} >active</option>
                    <option value={false} >un active</option>
                </select>
                <button className='btn_filter' onClick={Filter} >
                    {
                        state.Load ? "Loading ..." : `${translate('filter')}`
                    }
                </button>
            </div>
        </div>
    )
}

export default FilterRequest

